import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../../../common/theme/ISpcTheme';

export type ThreeSixtyViewToggleClasses = 'toggleContainer' | 'activeIcon' | 'icon';

const threeSixtyViewToggleStyles = makeStyles<ISpcTheme, ThreeSixtyViewToggleClasses>(
  theme => ({
    toggleContainer: {
      background: theme.palette.common.white,
      display: 'flex',
      flexDirection: 'column',
      zIndex: 12,
      position: 'absolute',
      left: 0,
      boxShadow: `5px 5px 10px 0px ${theme.palette.background.label}`,
      top: '320px',
      [theme.breakpoints.down('md')]: {
        top: '150px',
      },
    },
    icon: {
      margin: 10,
      width: 20,
      height: 20,
      borderBottom: `2px solid transparent`,
      cursor: 'pointer',
    },
    activeIcon: {
      background: theme.palette.background.default,
      borderBottom: `2px solid ${theme.palette.primary.main}`,
    },
  }),
  { name: 'Customise_ThreeSixtyViewToggle' },
);

export default threeSixtyViewToggleStyles;
